export default "__VITE_ASSET__DUKHrWCK__"